import { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import styled from "styled-components";
import { ToastIcon } from "./toastIcons";

interface IProps {
  type?: "success" | "error" | "warn" | "info";
  position?:
    | "top-center"
    | "top-left"
    | "bottom-left"
    | "bottom-center"
    | "bottom-right"
    | "top-right";
  message?: string;
  error?: unknown;
  response?: AxiosResponse;
}

const Toast = ({
  type = "info",
  position,
  message = "",
  error,
  response
}: IProps) => {
  const ToastType = error ? "error" : response ? "success" : type;
  const Error = error as AxiosError;

  const toastMessage = message
    ? message
    : Error?.response?.data &&
      typeof Error.response?.data === "object" &&
      "error" in Error.response.data
    ? (Error.response.data as { error: string }).error
    : Error
    ? Error.message
    : response
    ? response?.data.message
    : "";

  return toast[ToastType](toastMessage, {
    position: position,
    theme: "colored",
    hideProgressBar: true,
    icon: <IconContainer>{ToastIcon[ToastType]}</IconContainer>
  });
};

export default Toast;

const IconContainer = styled.div`
  width: 2.4rem;
  height: 2.4rem;
`;
